import { ChargerEstimatorData } from "..";

// sessionStorage, so the draft dies with the tab rather than lingering on a shared machine.
const DRAFT_KEY_PREFIX = "chargerEstimatorDraft";

/** The portal scopes drafts by vendor slug so two portals never share answers. */
export const estimatorDraftKey = (scope?: string) =>
  scope ? `${DRAFT_KEY_PREFIX}:${scope}` : DRAFT_KEY_PREFIX;

export const loadEstimatorDraft = (
  key: string,
): Partial<ChargerEstimatorData> => {
  try {
    return JSON.parse(sessionStorage.getItem(key) ?? "null") ?? {};
  } catch {
    return {};
  }
};

export const saveEstimatorDraft = (key: string, data: ChargerEstimatorData) => {
  try {
    // Files can't be serialised; the power access step asks for them again.
    const draft: ChargerEstimatorData = {
      ...data,
      electricalPanelPhoto: null,
      mainBreakerPhoto: null,
    };
    sessionStorage.setItem(key, JSON.stringify(draft));
  } catch {
    // Storage blocked or full: the estimator still works, it just won't survive a refresh.
  }
};

/** Drops every estimator draft in this tab, e.g. on sign-out or once a quote is filed. */
export const clearEstimatorDrafts = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(DRAFT_KEY_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {}
};
